export default function useEventLateEntryStart(shows: PortalShow[]) {
  const lateEntryStarts = shows
    .flatMap((show) => {
      const baseFee = show.entry_fees?.[0]?.[1]

      if (typeof baseFee !== 'number') {
        return []
      }

      return (show.entry_fees ?? [])
        .slice(1)
        .filter(
          ([date, fee]) =>
            typeof date === 'string' &&
            useTime(date).isValid() &&
            typeof fee === 'number' &&
            fee > baseFee,
        )
        .map(([date]) => date as string)
    })
    .sort((a, b) => useTime(a).diff(useTime(b)))

  return lateEntryStarts[0]
}
